var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFreeTrial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#free-trial_svg__clip0_11804_67452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.333 7h-1.667V3.667h-3.333V7H13.666V3.667h-3.333V7H8.666a3.343 3.343 0 00-3.333 3.333V37c0 1.833 1.5 3.333 3.333 3.333h26.667c1.833 0 3.333-1.5 3.333-3.333V10.333C38.666 8.5 37.166 7 35.333 7zm0 30H8.666V18.667h26.667V37zm0-21.667H8.666v-5h26.667v5z",
    fill: "url(#free-trial_svg__paint0_linear_11804_67452)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 21h-3v3h3v-3zm0 5h-3v3h3v-3zm3-5h3v3h-3v-3zm3 5h-3v3h3v-3zm3-5h3v3h-3v-3zm3 5h-3v3h3v-3zm3-5h3v3h-3v-3zm3 5h-3v3h3v-3zm-21 5h3v3h-3v-3zm9 0h-3v3h3v-3z",
    fill: "url(#free-trial_svg__paint1_linear_11804_67452)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-trial_svg__paint0_linear_11804_67452",
    x1: 23.96,
    y1: 72.528,
    x2: 51.709,
    y2: 61.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-trial_svg__paint1_linear_11804_67452",
    x1: 23.735,
    y1: 45.415,
    x2: 37.236,
    y2: 35.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "free-trial_svg__clip0_11804_67452"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h40v40H0z"
  })))));
}

export default SvgFreeTrial;